import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider, createGlobalStyle, useTheme } from 'styled-components';
import { Reset } from 'styled-reset';
import { MediaAsContents } from '../../components/Media';
import { defaultLightTheme, zIndexModal } from '../default/';
import { useLightTheme } from '../hooks';
import { useDarkTheme } from '../hooks/useDarkTheme';
export const FIGSGlobalStyles = createGlobalStyle `
  @font-face {
    font-family: 'VarsityScriptJF';
    src: url('https://cdn.shopify.com/s/files/1/0139/8942/files/385F83_0_0.eot?1910856');
    src: url('https://cdn.shopify.com/s/files/1/0139/8942/files/385F83_0_0.eot?1910856#iefix') format('embedded-opentype'), url('https://cdn.shopify.com/s/files/1/0139/8942/files/385F83_0_0.woff2?1910867') format('woff2'), url('https://cdn.shopify.com/s/files/1/0139/8942/files/385F83_0_0.woff?1910867') format('woff'), url('https://cdn.shopify.com/s/files/1/0139/8942/files/385F83_0_0.ttf?1910867') format('truetype');
  }

  html, body {
    color: ${o => o.theme.color.deprecated.obsidian};
  }

  // hack to prevent Nosto from creating a horizontal overflow on the PDPs
  body {
    overflow-x: hidden;
  }

  html,
  body,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    font-family: ${o => o.theme.typography.deprecated.font.family.primary};
    letter-spacing: ${o => o.theme.typography.deprecated.letterSpacing.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: currentColor;
    text-decoration: inherit;
  }

  img {
    display: block;
    width: 100%;
  }

  img[id$='frndby_unit_loading'] {
    width: 20px;
  }

  button {
    background: transparent;
    border: 0;
    color: currentColor;
    cursor: pointer;
    font-family: inherit;
    font-size: 100%;
    margin: 0;
    padding: 0;
  }

  b,
  strong {
    font-weight: bold;
  }

  i,
  em {
    font-style: italic;
  }

  /* Ensure that zendesk's "Help" button does not overlay our first-party modals */
  iframe#launcher {
    z-index: ${zIndexModal - 1} !important;
  }
`;
export const ToplevelFigsThemeProvider = ({ children, theme = defaultLightTheme }) => (_jsx(ThemeProvider, { theme: theme, children: _jsxs(_Fragment, { children: [_jsx(Reset, {}), _jsx(FIGSGlobalStyles, {}), children] }) }));
export const NestedFigsThemeProvider = ({ children, themeDesktop: themeDesktopProp, themeMobile: themeMobileProp }) => {
    const currentTheme = useTheme();
    const darkTheme = useDarkTheme();
    const lightTheme = useLightTheme();
    const themeDesktop = themeDesktopProp === 'dark'
        ? darkTheme
        : themeDesktopProp === 'light'
            ? lightTheme
            : currentTheme;
    const themeMobile = themeMobileProp === 'dark' ? darkTheme : themeMobileProp === 'light' ? lightTheme : currentTheme;
    if (currentTheme.name === themeDesktop.name && currentTheme.name === themeMobile.name) {
        return children;
    }
    if (themeDesktop.name === themeMobile.name) {
        return _jsx(ThemeProvider, { theme: themeDesktop, children: children });
    }
    return (_jsxs(_Fragment, { children: [_jsx(MediaAsContents, { greaterThanOrEqual: 'md', children: _jsx(ThemeProvider, { theme: themeDesktop, children: children }) }), _jsx(MediaAsContents, { lessThan: 'md', children: _jsx(ThemeProvider, { theme: themeMobile, children: children }) })] }));
};
//# sourceMappingURL=provider.js.map